import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  TaxCodeCfgService,
  TaxCodeContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-sst',
  templateUrl: './sst.component.html',
  styleUrls: ['./sst.component.css']
})
export class SSTComponent implements OnInit, OnDestroy {
  @Input() txnType: string;
  @Input() taxType: string;
  @Input() sst: FormControl;

  @Output() sstChange = new EventEmitter<FormControl>();
  @Output() sstContainer = new EventEmitter<TaxCodeContainerModel>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<TaxCodeContainerModel[]> = new ReplaySubject<TaxCodeContainerModel[]>(1);
  sstList: TaxCodeContainerModel[];

  constructor( private taxService: TaxCodeCfgService ) {}

  ngOnInit() {
    this.subs.sink = this.taxService.get(this.apiVisa).subscribe(
      {next: resolve => {
        let emptyTax = new TaxCodeContainerModel();
        emptyTax.bl_fi_cfg_tax_code.tax_code = "";
        emptyTax.bl_fi_cfg_tax_code.tax_rate_txn = 0;
        const conditions1 = ["SST-SLS-OUTPUT", "SST-SVC-OUTPUT","GST-OUTPUT"];
        const conditions2 = ["INPUT", "PURCHASE"];
        
        this.sstList = [emptyTax,...resolve.data.filter(s => this.txnType==='SALES'?conditions1.some(el => s.bl_fi_cfg_tax_code.tax_gst_type.includes(el)):conditions2.some(el => s.bl_fi_cfg_tax_code.tax_gst_type.includes(el)))];
        if(this.taxType){
          this.sstList = this.sstList.filter(s => s.bl_fi_cfg_tax_code.tax_code==='' || s.bl_fi_cfg_tax_code.tax_gst_type==this.taxType);
        }
        
        this.filteredOptions$.next(this.sstList);
        if(this.sst.value){
          this.onSelectionChange(this.sst.value);
        }
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterSST(resolve)});
    
  }
  filterSST(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.sstList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.sstList.filter(s => s.bl_fi_cfg_tax_code.tax_code.toLowerCase().includes(search.toLowerCase().toString()));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const container = this.sstList.find(c => c.bl_fi_cfg_tax_code.tax_code === e);
    this.sstContainer.emit(container);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
